$(document).ready(function() {
    $('.btn-remove').on('click', function(e) {
        e.preventDefault();
        $url = $(this).attr('href');

        swal({
                title: "Ben je zeker?",
                text: "Je staat op het punt om dit item te verwijderen!",
                type: "warning",
                showCancelButton: true,
                cancelButtonText:"Annuleren",
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ja, verwijderen!",
                closeOnConfirm: false
            },
            function(){
                $.ajax({
                    url: $url,
                    type: 'GET',
                    success: function(result) {
                        swal("Succes!", "Het item is verwijderd.", "success");
                        location.reload();
                    },
                    error: function(result){
                        swal("Oops...", "Mislukt! Dit item is nog steeds in gebruik!", "error");
                    }
                });
            });
    });

});
